import PropTypes from 'prop-types';
import { default as React } from 'react';
import { FreeMode, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

const Carrousel = ({ items, slidesPerView = 5, spaceBetween = 20, navigation = true, modules = [FreeMode, Pagination, Navigation], ...props }) => {
  return (
    <Swiper
      slidesPerView={slidesPerView}
      spaceBetween={spaceBetween}
      pagination={{ clickable: true }}
      navigation={navigation}
      modules={modules}
      className="mySwiper"
      {...props}
    >
      {items.map((item, i) => (
        <SwiperSlide key={i}>{item}</SwiperSlide>
      ))}
    </Swiper>
  );
};

Carrousel.propTypes = {
  items: PropTypes.arrayOf(PropTypes.node).isRequired,
  modules: PropTypes.array,
  navigation: PropTypes.bool,
  slidesPerView: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  spaceBetween: PropTypes.number,
};

export default Carrousel;
